import React from 'react';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from 'styled-components';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';

import theme from '@crm-framework/theme';
import { ReduxInject } from '@crm-framework/saga-injector';

import { ToolsLayout, watchAppSagas } from '@crm-package/tools';

import { store } from './store';
import { WithdrawalForm } from './WithdrawalForm';
import { watchApp } from './sagas';

const history = createBrowserHistory();

store.runSaga(watchAppSagas);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <Router history={history}>
        <ToolsLayout name="BePaid Withdrawal Request">
          <ReduxInject keyName="bePaid" saga={watchApp}>
            <WithdrawalForm />
          </ReduxInject>
        </ToolsLayout>
      </Router>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
